<template>
  <v-container fluid class="primary py-0 px-0">
    <v-row>
      <!-- Content -->
      <v-col cols="12" class="py-0">
        <v-row>
          <v-col class="py-0">
            <v-text-field
              v-model="query"
              prepend-inner-icon="search"
              type="search"
              label="Quick search"
              color="info"
              clearable
              class="search-bar"
              autocomplete="off"
              hide-details="true"
              @click:clear="clearSearch()"
            />
          </v-col>
        </v-row>
        <div>
          <v-row v-show="results.count > 0" class="pl-5">
            <v-col class="px-0 py-0">
              <div class="d-inline-block">
                <v-subheader class="pl-0">
                  {{ results.count }} results
                </v-subheader>
              </div>
            </v-col>
          </v-row>
          <div
            :style="'height: calc(100vh - 170px); overflow-x: none; overflow-y: auto;'"
          >
            <v-alert v-if="loadingSearch" color="secondary" type="info" class="mt-5">
              <span>Loading ....</span>
            </v-alert>
            <InfoExternalTable
              v-else-if="results.count > 0"
              :hits="results.items"
              :edit="onClickItem"
              :hide-common-headers="true"
              :custom-headers="getCustomHeaders(contentType)"
              :show-more="showMore"
              :loading="loadingSearch"
            />
            <v-alert v-else color="secondary" type="info" class="mt-5">
              <span>No results</span>
            </v-alert>
          </div>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup>
import { ref, computed, watch, onMounted } from 'vue';
import { useStore } from 'vue2-helpers/vuex';
import { useQuery } from '@vue/apollo-composable';

import InfoExternalTable from '@/components/search/InfoExternalTable.vue';

import { getCustomHeaders } from '@/utils/content';
import { getGraphqlSchema } from '../../../graphql/index';

// eslint-disable-next-line no-undef
const props = defineProps({
  service: { type: String, default: () => '' },
  contentType: { type: Object, default: () => {} },
  onClickItem: { type: Function, default: () => {} },
  filters: { type: Array, default: () => [] }
});

const store = useStore();

const query = ref('');
const start = ref(0);
const limit = 20;
const filters = computed(() => {
  const filtersObject = {
    query: query.value,
    start: start.value,
    limit: 20,
    codeTerminal: store.getters.workspace?.settings?.codeTerminal || null,
    codeSite: store.getters.workspace?.settings?.codeSite || null
  };

  props.filters.forEach(filter => {
    filtersObject[filter.field] = filter.value;
  });

  return filtersObject;
});

const loadingSearch = ref(false);

const results = ref({
  count: 0,
  items: []
});

const { onResult } = useQuery(
  getGraphqlSchema(`horanetExternalContents_${props.service}`),
  { filters },
  { enabled: true, fetchPolicy: 'no-cache', throttle: 1000 }
);

onResult(result => {
  if (result.loading) {
    return;
  }

  if (start.value > 0) {
    results.value.items = results.value.items.concat(
      result.data.horanetExternalContents[props.service].items
    );
  } else {
    results.value.count = result.data.horanetExternalContents[props.service].count;
    results.value.items = result.data.horanetExternalContents[props.service].items;
  }

  loadingSearch.value = false;
});

const showMore = () => {
  const newStart = start.value + limit;
  if (newStart < results.value.count) {
    start.value = newStart;
  }
};

const clearSearch = () => {
  query.value = '';
  start.value = 0;
};

onMounted(() => {
  loadingSearch.value = true;
});

watch(query, (newValue, oldValue) => {
  if (newValue !== oldValue) {
    loadingSearch.value = true;
    start.value = 0;
  }
});
</script>
<style scoped>
.search-bar {
  width: 100% !important;
}
</style>
